import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// utils
// import axios from '../../utils/axios';
import { MenuData } from '../../@type/menu';

// ----------------------------------------------------------------------

type MenuState = {
  isLoading: boolean;
  error: boolean;
  menuList: MenuData[];
};

const initialState: MenuState = {
  isLoading: false,
  error: false,
  menuList: []
};

const slice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state: MenuState) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state: MenuState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = Boolean(action.payload);
    },

    // GET MERCHANT
    getMenusSuccess(state: MenuState, action: PayloadAction<MenuData[]>) {
      state.isLoading = false;
      state.menuList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const { getMenusSuccess } = slice.actions;
// Actions

// ----------------------------------------------------------------------
